import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import {Delete} from '@mui/icons-material'
import FormControl from '@mui/material/FormControl'
import Checkbox from '@mui/material/Checkbox'
import IconButton from '@mui/material/IconButton'
import FormControlLabel from '@mui/material/FormControlLabel'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import MultiSelect from 'components/MultiSelect'
import {fieldtype} from 'utils/enums/fieldtype'

const Container = styled.div`
    margin-bottom: 20px;
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Title = styled.div`
    border-bottom: 2px solid rgb(74, 74, 74);
    margin: 20px 0;
    padding-bottom: 5px;
    font-size: 20px;
    display: flex;
    align-items: center;

    > button {
        margin-left: auto;
        padding: 10px;
    }
`

const Label = styled.div`
    color: rgba(0, 0, 0, 0.54);
    font-size: 12px;
`

const Control = styled(FormControl)`
	margin-bottom: 20px;
	width: 100%;
`

const CREATE_FIELD_VALUE = -1
const NO_VALUE = -1

class Dataset extends React.Component {
    constructor(props) {
        super(props)
        this.fromToFields = []
        this.durationFields = []
        this.colorFields = []
        this.labelFields = []
        this.filterFields = []
    }

    handleChange = (e, value) => {
        if (e === null) {
            this.props.handleChange({
                labelFieldsId: value ? value.map(item => item.value) : []
            }, this.props.index)
        } else if (e.target.name === 'durationField') {
            this.props.handleChange({
                toFieldId: e.target.checked ? null : this.toFields.length ? this.toFields[0].id : -1,
                durationFieldId: e.target.checked ? this.durationFields.length ? this.durationFields[0].id : -1 : null
            }, this.props.index)
        } else {
            this.props.handleChange({
                [e.target.name]: e.target.value
            }, this.props.index)
        }
    }

    getFields = (entity, types, exception) => {
        if (entity && types) {
            return this.props.entities.find(obj =>
                obj.id === entity).fields.filter(item =>
                    types.find(type => type === item.uiType) && item.id !== exception)
        } else {
            return []
        }
    }

    render() {
        const {intl, entityId} = this.props
        this.fromFields = this.getFields(entityId, [fieldtype.datetime], this.props.toFieldId)
        this.toFields = this.getFields(entityId, [fieldtype.datetime], this.props.fromFieldId)
        this.durationFields = this.getFields(entityId, [fieldtype.number])
        this.colorFields = this.getFields(entityId, [fieldtype.check, fieldtype.linkedfield])
        this.filterFields = this.getFields(entityId, [fieldtype.check, fieldtype.linkedfield])
        this.labelFields = this.getFields(entityId, [
            fieldtype.number,
            fieldtype.linkedfield,
            fieldtype.text,
            fieldtype.textarea,
            fieldtype.datetime,
            fieldtype.phone,
            fieldtype.email,
            fieldtype.url
        ])

        const labelFieldsId = this.props.labelFieldsId.length ? this.props.labelFieldsId.filter(obj =>
            this.labelFields.find(field => field.id === obj)) : []

        return (
            <Wrapper>
                {this.props.count > 1 &&
                    <Title>
                        {this.props.entities.find(item => item.id === entityId).singular}
                        <IconButton onClick={() => this.props.deleteDataset(this.props.index)}>
                            <Delete />
                        </IconButton>
                    </Title>
                }
                {this.props.entities && this.props.entities.length &&
                    <Control variant="standard">
                        <InputLabel>{intl.formatMessage({id: "main.planning_entity"})}</InputLabel>
                        <Select
                            value={entityId}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'entityId'
                            }}
                        >
                            {this.props.entities.map((item, index) =>
                                <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                            )}
                        </Select>
                    </Control>
                }
                <Control variant="standard">
                    <InputLabel>{intl.formatMessage({id: "main.planning_field_from"})}</InputLabel>
                    <Select
                        value={this.props.fromFieldId}
                        onChange={this.handleChange}
                        inputProps={{
                            name: 'fromFieldId'
                        }}
                    >
                        {this.fromFields.map((item, index) =>
                            <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                        )}
                        <MenuItem value={CREATE_FIELD_VALUE}>
                            {intl.formatMessage({id: "main.planning_create_field"})}
                        </MenuItem>
                    </Select>
                </Control>
                {this.props.durationFieldId ?
                    <Control variant="standard">
                        <InputLabel>{intl.formatMessage({id: "main.planning_field_duration"})}</InputLabel>
                        <Select
                            value={this.props.durationFieldId}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'durationFieldId'
                            }}
                        >
                            {this.durationFields.map((item, index) =>
                                <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                            )}
                            <MenuItem value={CREATE_FIELD_VALUE}>
                                {intl.formatMessage({id: "main.planning_create_field"})}
                            </MenuItem>
                        </Select>
                    </Control>
                    :
                    <Control variant="standard">
                        <InputLabel>{intl.formatMessage({id: "main.planning_field_to"})}</InputLabel>
                        <Select
                            value={this.props.toFieldId}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'toFieldId'
                            }}
                        >
                            {this.toFields.map((item, index) =>
                                <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                            )}
                            <MenuItem value={CREATE_FIELD_VALUE}>
                                {intl.formatMessage({id: "main.planning_create_field"})}
                            </MenuItem>
                        </Select>
                    </Control>
                }
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={this.props.durationFieldId ? true : false}
                            name="durationField"
                            onChange={this.handleChange}
                        />
                    }
                    label={intl.formatMessage({id: "main.planning_use_event_duration"})}
                    sx={{marginBottom: '20px'}}
                />
                <Control variant="standard">
                    <InputLabel>{intl.formatMessage({id: "main.planning_color_field"})}</InputLabel>
                    <Select
                        value={this.props.colorFieldId}
                        onChange={this.handleChange}
                        inputProps={{
                            name: 'colorFieldId'
                        }}
                    >
                        <MenuItem value={NO_VALUE}>
                            {intl.formatMessage({id: "main.planning_none"})}
                        </MenuItem>
                        {this.colorFields.map((item, index) =>
                            <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                        )}
                    </Select>
                </Control>
                <Container>
                    <Label>{intl.formatMessage({id: "main.planning_label_fields"})}</Label>
                    <MultiSelect
                        value={labelFieldsId.length ? labelFieldsId.map(item => {
                            return {
                                value: item,
                                label: this.labelFields.find(field => field.id === item).singular
                            }}) : null
                        }
                        options={this.labelFields.map(item => { return {value: item.id, label: item.singular} })}
                        onChange={(value) => this.handleChange(null, value)}
                    />
                </Container>
                <Control variant="standard">
                    <InputLabel>{intl.formatMessage({id: "main.planning_filter_field"})}</InputLabel>
                    <Select
                        value={this.props.filterFieldId}
                        onChange={this.handleChange}
                        inputProps={{
                            name: 'filterFieldId'
                        }}
                    >
                        <MenuItem value={NO_VALUE}>
                            {intl.formatMessage({id: "main.planning_none"})}
                        </MenuItem>
                        {this.filterFields.map((item, index) =>
                            <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                        )}
                    </Select>
                </Control>
                <TextField variant="standard"
                    value={this.props.defaultDuration}
                    type='number'
                    onChange={this.handleChange}
                    label={intl.formatMessage({id: "main.planning_default_duration"})}
                    sx={{marginBottom: '20px', width: '100%'}}
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{
                        name: 'defaultDuration'
                    }}
                />
            </Wrapper>
        )
    }
}

export default injectIntl(Dataset)
